'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_OPTIONS = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = require('babel-runtime/helpers/extends');

var _extends6 = _interopRequireDefault(_extends5);

var _dayjs = require('dayjs');

var _dayjs2 = _interopRequireDefault(_dayjs);

var _propTypes = require('prop-types');

var _constants = require('../constants');

var _nonCanonical = require('./nonCanonical');

var _getBettingAccountLoggedInStatus = require('./cookie/getBettingAccountLoggedInStatus');

var _getBettingAccountLoggedInStatus2 = _interopRequireDefault(_getBettingAccountLoggedInStatus);

var _getUserName = require('./cookie/getUserName');

var _getUserName2 = _interopRequireDefault(_getUserName);

var _getUserId = require('./cookie/getUserId');

var _getUserId2 = _interopRequireDefault(_getUserId);

var _commonTraits = require('./commonTraits');

var _getUTMParams = require('./utm/getUTMParams');

var _getUTMParams2 = _interopRequireDefault(_getUTMParams);

var _getBetslipId = require('./getBetslipId');

var _traits = require('../traits');

var _configProvider = require('./configProvider');

var _configProvider2 = _interopRequireDefault(_configProvider);

var _getScreenProps = require('./getScreenProps');

var _getScreenProps2 = _interopRequireDefault(_getScreenProps);

var _getLocationAndSubsection = require('./getLocationAndSubsection');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var utc = require('dayjs/plugin/utc');
var timezone = require('dayjs/plugin/timezone');

_dayjs2.default.extend(utc);
_dayjs2.default.extend(timezone);
var DEFAULT_OPTIONS = exports.DEFAULT_OPTIONS = {
    integrations: {
        All: true
    }
};

function track(event) {
    var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_OPTIONS;
    var shouldHaveSiteSections = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    var _extends4;

    var shouldHaveLocationAndSubsection = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var shouldGetBetslipId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    var _configProvider$getEv = _configProvider2.default.getEvent(event),
        getPropTypes = _configProvider$getEv.getPropTypes,
        buildProps = _configProvider$getEv.buildProps;

    var props = (0, _extends6.default)({}, traits);

    if (getPropTypes) {
        (0, _propTypes.checkPropTypes)(getPropTypes(), traits, 'trait', event + ' event');
    }

    if (buildProps) {
        props = buildProps(traits);
    }

    // Overwrite segment defaults to use a non canonical values
    var properties = {
        path: (0, _nonCanonical.getNonCanonicalPath)(),
        url: (0, _nonCanonical.getNonCanonicalUrl)()
    };

    var userName = (0, _getUserName2.default)();
    if (userName) {
        properties[_traits.TRAIT_USER_NAME] = userName;
    }

    var userId = (0, _getUserId2.default)();
    if (userId) {
        properties[_traits.TRAIT_USER_ID] = userId;
    }

    var traitsProps = (0, _commonTraits.getCommonTraits)();
    var screenProps = (0, _getScreenProps2.default)();

    if (traitsProps && traitsProps[_traits.TRAIT_SITE_SECTION] && shouldHaveSiteSections) {
        var subsection = localStorage.getItem(_traits.TRAIT_SUBSECTION);

        properties[_traits.TRAIT_SITE_SECTION] = traitsProps[_traits.TRAIT_SITE_SECTION];
        properties[_traits.TRAIT_SITE_SUB_SECTION_1] = traitsProps[_traits.TRAIT_SITE_SUB_SECTION_1];
        properties[_traits.TRAIT_SITE_SUB_SECTION_2] = traitsProps[_traits.TRAIT_SITE_SUB_SECTION_2];

        if (subsection) {
            properties[_traits.TRAIT_SUBSECTION] = subsection;
        }
    }

    if (shouldHaveLocationAndSubsection) {
        var _extends2;

        var _getLocationAndSubsec = (0, _getLocationAndSubsection.getLocationAndSubsection)(),
            location = _getLocationAndSubsec.location,
            _subsection = _getLocationAndSubsec.subsection;

        properties = (0, _extends6.default)({}, properties, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, _traits.TRAIT_LOCATION, location), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_SUBSECTION, _subsection), _extends2));
    }

    if (shouldGetBetslipId) {
        properties = (0, _extends6.default)({}, properties, (0, _defineProperty3.default)({}, _traits.TRAIT_BETSLIP_ID, (0, _getBetslipId.getBetslipId)()));
    }

    localStorage.removeItem('subsection');

    var ukTimestamp = (0, _dayjs2.default)().tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    properties = (0, _extends6.default)((_extends4 = {}, (0, _defineProperty3.default)(_extends4, _traits.TRAIT_LOGGED_IN_STATUS, userId ? 'Logged In' : 'Logged Out'), (0, _defineProperty3.default)(_extends4, _traits.TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS, (0, _getBettingAccountLoggedInStatus2.default)() ? 'Logged In' : 'Logged Out'), (0, _defineProperty3.default)(_extends4, _traits.TRAIT_UK_TIMESTAMP, ukTimestamp), _extends4), properties, (0, _getUTMParams2.default)(), props);

    return new Promise(function (resolve) {
        if (!global.analytics || !global.analytics.initialize) {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
            resolve();
            return;
        }

        global.analytics.track(event, properties, (0, _extends6.default)({}, screenProps, options), resolve);
    });
}

exports.default = track;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/track.js
// module id = 14
// module chunks = 1